import log from 'salvo-lite/log'
import axios from 'axios'

class GiftMessage {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._elem.addEventListener('keypress', e => {
            let value = this._elem.value
            console.log(value)
            axios.post('/cart/update.js', {
                attributes: {
                    giftMessage: value
                }
            }).then(response => {
                console.log(response.data.attributes)
            }).catch(error => {
                console.error(error)
            })
        })
    }
}

export default GiftMessage



// WEBPACK FOOTER //
// ./src/resources/scripts/components/GiftMessage.js